import { ThemeOptions, keyframes } from '@mui/material/styles';
import '@assets/fonts/fonts.css';
import colors from '@theme/colors';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const slide = keyframes`from { left: -284px } to { left: 0 }`;

declare module '@mui/material/styles' {
  interface Theme {
    shape: {
      borderRadius: number;
      buttonRadius?: string;
    };
    animations: {
      spin: string;
      slide: string;
    };
    icons: {
      xs: {
        height: string;
        width: string;
      };
      sm: {
        height: string;
        width: string;
      };
      md: {
        height: string;
        width: string;
      };
    };
    borders: {
      radius: number;
      main: string;
      dark: string;
      white: string;
      green: string;
      blue: string;
    };
    boxShadow: {
      1: string;
      2: string;
      3: string;
      4: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    animations?: {
      spin: string;
      slide: string;
    };
    icons: {
      xs: {
        height: string;
        width: string;
      };
      sm: {
        height: string;
        width: string;
      };
      md: {
        height: string;
        width: string;
      };
    };
    borders: {
      radius: number;
      main: string;
      dark: string;
      white: string;
      green: string;
      blue: string;
    };
    boxShadow: {
      1: string;
      2: string;
      3: string;
      4: string;
    };
  }
}

export const themeBase = {
  // shapes TODO add border radius, should be 4, need some that are 8?
  boxShadow: {
    1: 'none',
    2: '0px 2px 8px 1px rgba(0, 0, 0, 0.16)',
    3: '0px 8px 20px -8px rgba(0, 0, 0, 0.25)',
    4: '0px 8px 40px rgba(0, 0, 0, 0.2)',
  },
  shape: {
    borderRadius: 2,
    buttonRadius: '50%',
  },
  borders: {
    radius: 4,
    main: `1px solid ${colors.BLACK_10}`,
    dark: `1px solid ${colors.BLACK_100}`,
    white: `1px solid ${colors.WHITE_10}`,
    green: `1px solid ${colors.SEAFOAM_SUPPLEMENTAL}`,
    blue: `1px solid ${colors.NAVY}`,
  },
  // shadows TODO add boxshadow,
  // elevation
  icons: {
    xs: {
      height: '16px',
      width: '16px',
    },
    sm: {
      height: '20px',
      width: '20px',
    },
    md: {
      height: '24px',
      width: '24px',
    },
  },
  animations: {
    spin: `${spin} 0.9s infinite linear`,
    slide: `${slide} 150ms ease forwards`,
  },
} as ThemeOptions;
